// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "organization_service_variant".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "organization_service_variant" table (1:1 with a DB row, on the wire). */
export const organizationServiceVariantAtomSchema = z.object({
    id: z.string(),
    serviceId: z.string(),
    name: z.string(),
    priceCents: z.number().nullable(),
    durationMinutes: z.number().nullable(),
    sortOrder: z.number(),
    isActive: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=organizationServiceVariant.js.map